<template>
  <div class="box">
    <Tab :list="tabs" @change="changeTab" />
    <CommonSwiper
      :options="options"
      :show-pagination="false"
      @ready="
        swiper = $event
        $emit('ready', $event)
      "
    >
      <div class="swiper-wrapper">
        <slot />
      </div>
    </CommonSwiper>
  </div>
</template>

<script>
import Tab from './Tab'
export default {
  components: {
    Tab
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    async: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: null
    }
  },
  methods: {
    changeTab($event) {
      this.cur = $event
      !this.async && this.swiper.swipeTo($event)
      this.$emit('change', $event)
    }
  }
}
</script>
